module.exports = __webpack_public_path__ + "img/illustration-uk.a64c2f23.svg";